/**
 * Waits for the browser to paint by awaiting two animation frames.
 * A single requestAnimationFrame fires before paint; the nested
 * second one fires after paint, ensuring pending UI updates
 * (e.g. snackbars, spinners) are visible before heavy synchronous
 * work begins on the main thread.
 */
export const waitForUI = (): Promise<void> =>
    new Promise((resolve) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => resolve());
        });
    });
